<template>
  <div class="submit-invoice">
    <div class="submit-invoice__container">
      <div class="submit-invoice__type" v-if="isMobile">
        <span>发票类型</span>
        <div @click="selectType(0)" :class="selectTypeVal == 0 && 'high-light'">增值税普通发票</div>
        <div @click="selectType(1)" :class="selectTypeVal == 1 && 'high-light'">增值税专用发票</div>
      </div>
      <el-form class="submit-invoice__form" label-position="right" :model="ruleForm" :rules="rules" ref="ruleForm" :label-width="isMobile ? '110px' : '130px'">
        <el-form-item label="发票类型" prop="invoiceType" v-if="!isMobile">
          <el-radio v-model="ruleForm.invoiceType" label="0" @input="selectType">增值税普通发票</el-radio>
          <el-radio v-model="ruleForm.invoiceType" label="1" @input="selectType">增值税专用发票</el-radio>
        </el-form-item>
        <p :class="isMobile ? 'mobile-title' : 'title'">发票信息</p>
        <el-form-item label="企业名称" prop="invoiceTitle">
          <el-input v-model="ruleForm.invoiceTitle"></el-input>
        </el-form-item>
        <el-form-item label="纳税人识别号" prop="taxpayerCode">
          <el-input v-model="ruleForm.taxpayerCode"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="invoiceAddress">
          <el-input v-model="ruleForm.invoiceAddress"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="invoicePhone">
          <el-input v-model="ruleForm.invoicePhone"></el-input>
        </el-form-item>
        <el-form-item label="开户行" prop="openBank">
          <el-input v-model="ruleForm.openBank"></el-input>
        </el-form-item>
        <el-form-item label="账号" prop="bankAccount">
          <el-input v-model="ruleForm.bankAccount"></el-input>
        </el-form-item>
      </el-form>
      <!--      <el-form class="submit-invoice__form" label-position="right" :model="addressInfo" :rules="addressRules" ref="addressForm" :label-width="isMobile ? '80px' : '130px'">-->
      <div :class="!isMobile && 'submit-invoice__form__content'">
        <p :class="isMobile ? 'mobile-title' : 'title'">收件地址</p>
        <div class="address-wrapper" :class="isMobile && 'pr-0'">
          <ul class="address-wrapper__container" :class="{ more: isMore && !isMobile, 'h-130': isMore && isMobile }">
            <li v-for="(item, idx) in addressList" :key="item.id">
              <span v-if="!isMobile" class="consignee" @click="selectConsignee(idx, item)" :class="{ active: activeIdx == idx }">{{ item.contactor }}</span>
              <div class="address-wrapper__container__item" :class="{ 'm-active': activeIdx == idx && isMobile, 'pb-1': isMobile, 'w-80': !isMobile }" @click="selectConsignee(idx, item)">
                <p :class="isMobile && 'w-auto'">
                  <span>{{ item.contactor }}</span>
                  <span>{{ item.province }}</span>
                  <span>{{ item.city }}</span>
                  <span>{{ item.county }}</span>
                  <span>{{ item.address }}</span>
                  <span>{{ item.phone }}</span>
                  <a v-if="item.isDefault == 1 && isMobile" :class="isMobile && 'pl-0'">默认地址</a>
                </p>
                <a v-if="item.isDefault == 1 && !isMobile">默认地址</a>
              </div>
            </li>
          </ul>
          <div class="address-wrapper__opt" :class="isMobile && 'prl-20'">
            <span @click="showMore" class="more-address" v-if="isMore" :class="isMobile && 'mr-0'">
              更多地址
              <i class="el-icon-caret-bottom"></i>
            </span>
            <span v-else class="more-address" @click="showMore" :class="isMobile && 'mr-0'">
              收起地址
              <i class="el-icon-caret-top"></i>
            </span>
            <a @click="showAddressInfo = !showAddressInfo" class="main-text" :class="isMobile && 'btn w-100'">新增地址</a>
            <div class="btn" :class="isMobile && 'w-100'" @click="save" v-if="showAddressInfo">保存</div>
          </div>
        </div>
        <!--        <div v-if="showAddressInfo">-->
        <el-form
          v-if="showAddressInfo"
          class="submit-invoice__form"
          :class="!isMobile && 'p-0'"
          label-position="right"
          :model="addressInfo"
          :rules="addressRules"
          ref="addressForm"
          :label-width="isMobile ? '80px' : '130px'"
        >
          <el-form-item label="收货人" prop="contactor">
            <el-input v-model="addressInfo.contactor"></el-input>
          </el-form-item>
          <el-form-item label="所在地区" prop="province">
            <v-distpicker :province="addressInfo.province" :city="addressInfo.city" :area="addressInfo.county" @province="onChangeProvince" @city="onChangeCity" @area="onChangeArea"></v-distpicker>
          </el-form-item>
          <el-form-item label="详细地址" prop="address">
            <el-input v-model="addressInfo.address"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="phone">
            <el-input v-model="addressInfo.phone"></el-input>
          </el-form-item>
          <el-form-item label="电子邮箱" prop="email">
            <el-input v-model="addressInfo.email"></el-input>
          </el-form-item>
          <!--        </div>-->
        </el-form>
      </div>
    </div>
    <div class="submit-invoice__footer" v-if="isMobile">
      <span @click="closeHandler" class="mobile-btn ">取 消</span>
      <span @click="confirm" class="mobile-btn ">确 定</span>
    </div>
  </div>
</template>

<script>
import invoice from '@api/invoice'

export default {
  name: 'SubmitInvoiceContent',
  props: {
    ids: {
      default: ''
    }
  },
  data() {
    const validateArea = (rule, value, callback) => {
      let isAddressError = this.addressInfo.province.length <= 1 || this.addressInfo.city.length <= 1 || this.addressInfo.county.length <= 1
      if (isAddressError) {
        callback(new Error('请选择所在地区'))
      } else {
        callback()
      }
    }
    return {
      showAddressInfo: false,
      addressList: [],
      isMore: true,
      activeIdx: null,
      selectTypeVal: null,
      // ids: '',
      ruleForm: {
        invoiceType: null,
        invoiceTitle: '',
        taxpayerCode: '',
        invoiceAddress: '',
        invoicePhone: '',
        openBank: '',
        bankAccount: ''
      },
      rules: {
        invoiceType: [{ required: true, message: '请选择发票类型', trigger: 'change' }],
        invoiceTitle: [{ required: true, message: '请输入企业名称' }],
        taxpayerCode: [{ required: true, message: '请输入纳税人识别号' }],
        invoiceAddress: [{ trigger: 'change' }],
        invoicePhone: [{ trigger: 'change' }],
        openBank: [{ trigger: 'change' }],
        bankAccount: [{ trigger: 'blur' }]
      },
      addressInfo: {
        contactor: '',
        address: '',
        phone: '',
        email: '',
        // area: '',
        city: '',
        province: '',
        county: ''
      },
      addressRules: {
        contactor: [{ required: true, message: '请输入收货人', trigger: 'change' }],
        province: [{ required: true, validator: validateArea, trigger: 'change' }],
        address: [{ required: true, message: '请输入详细地址', trigger: 'change' }],
        phone: [{ required: true, message: '请输入联系电话', trigger: 'change' }],
        email: [{ required: true, message: '请输入电子邮箱', trigger: 'change' }]
      }
    }
  },
  created() {
    this.getAddressList()
    if (this.isMobile) this.selectType(0)
  },
  computed: {
    isMobile() {
      return this.$store.state.book.isMobile
    }
  },
  methods: {
    selectType(val) {
      this.selectTypeVal = val
      if (val == 0) {
        this.rules.invoiceTitle = [{ required: true, message: '请输入企业名称', trigger: 'change' }]
        this.rules.taxpayerCode = [{ required: true, message: '请输入纳税人识别号', trigger: 'change' }]
        this.rules.invoiceAddress = [{ required: false, trigger: 'change' }]
        this.rules.invoicePhone = [{ required: false }]
        this.rules.openBank = [{ required: false, trigger: 'change' }]
        this.rules.bankAccount = [{ required: false, trigger: 'change' }]
      } else {
        // 专票
        this.rules.invoiceTitle = [{ required: true, message: '请输入企业名称', trigger: 'change' }]
        this.rules.taxpayerCode = [{ required: true, message: '请输入纳税人识别号', trigger: 'change' }]
        this.rules.invoiceAddress = [{ required: true, message: '请选择所在地区', trigger: 'change' }]
        this.rules.invoicePhone = [{ required: true, message: '请输入电话', trigger: 'change' }]
        this.rules.openBank = [{ required: true, message: '请输入开户行', trigger: 'change' }]
        this.rules.bankAccount = [{ required: true, message: '请输入账号', trigger: 'change' }]
      }
    },
    selectConsignee(idx, item) {
      this.addressId = item.id
      this.activeIdx = idx
    },
    getAddressList() {
      invoice.getAddressList().then((res) => {
        let { status, data } = res.data
        if (status === 0) {
          this.addressList = data
          this.selectConsignee(0, this.addressList[0])
        }
      })
    },
    showMore() {
      this.isMore = !this.isMore
    },
    onChangeProvince(val) {
      this.addressInfo.province = val.value
    },
    onChangeCity(val) {
      this.addressInfo.city = val.value
    },
    onChangeArea(val) {
      this.addressInfo.county = val.value
    },
    save() {
      this.$refs['addressForm'].validate((valid) => {
        if (valid) {
          invoice.addressSave(this.addressInfo).then((res) => {
            let { status } = res.data
            if (status == 0) {
              this.$message.success('添加成功')
              this.isMore = false
              if (this.isMobile) {
                this.showAddressInfo = false
                this.$refs['addressForm'].resetFields()
              }
              this.getAddressList()
            } else {
              this.$message.error('添加失败')
            }
          })
        } else {
          return false
        }
      })
    },
    closeHandler() {
      this.showAddressInfo = false
      this.isMore = true
      this.activeIdx = null
      this.selectConsignee(0, this.addressList[0])
      if (this.isMobile) {
        this.$parent.isSubmit = false
      } else {
        this.$parent.visible = false
      }
      this.resetForm()
    },
    applyInvoice() {
      let invoiceInfo = {
        bankAccount: ' ',
        openBank: '',
        invoiceAddress: '',
        invoicePhone: '',
        invoiceTitle: '',
        taxpayerCode: ''
      }
      for (let key in invoiceInfo) {
        invoiceInfo[key] = this.ruleForm[key]
      }
      const params = {
        ids: this.ids,
        addressId: this.addressId,
        invoiceType: this.isMobile ? this.selectTypeVal : this.ruleForm.invoiceType,
        invoiceInfo: JSON.stringify(invoiceInfo)
      }
      invoice.applyInvoice(params).then((invoice) => {
        let { status, data } = invoice.data
        if (status == 0) {
          this.closeHandler()
          this.$message.success('成功')
          this.$parent.getData()
        } else {
          this.$message.error(data)
        }
      })
    },
    confirm() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.applyInvoice()
        } else {
          return false
        }
      })
    },
    resetForm() {
      this.$refs['ruleForm'].resetFields()
      this.$refs['addressForm']?.resetFields()
      this.selectType(0)
      for (let key in this.addressInfo) {
        this.addressInfo[key] = ''
      }
    }
  }
}
</script>

<style scoped lang="scss">
.submit-invoice {
  &__type {
    display: flex;
    gap: 3px;
    align-items: center;
    justify-content: space-between;
    margin: 10px 0;
    font-size: 14px;
    padding: 0 20px;
    div {
      padding: 5px 7px;
      border: 1px solid #cecece;
      cursor: pointer;
    }
    .high-light {
      border-color: #df5813;
      color: #df5813;
    }
  }
  &__container {
    height: 580px;
    overflow-y: scroll;
    //padding: 0 20px 20px 20px;
    padding-bottom: 20px;
    text-align: left;
  }

  &__form {
    padding-left: 20px;

    &__content {
      padding: 0 20px;
    }
    /deep/.el-input__inner {
      border-radius: 0;
    }
    .el-input {
      width: 90%;
    }
    .el-select {
      width: 135px;
      margin-right: 10px;
    }
  }
  .p-0 {
    padding-left: 0;
  }
  .title {
    margin-bottom: 20px;
    font-size: 18px;
    color: #515151;
    line-height: 40px;
    border-bottom: 1px solid #f3f3f7;
  }
  .mobile-title {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    color: #515151;
  }

  .address-wrapper {
    padding-right: 46px;
    &__container {
      li {
        margin-bottom: 10px;
      }
      .m-active {
        background-color: #f3f3f7;
      }
      .pb-1 {
        width: 100%;
        border-bottom: 1px solid #f3f3f7;
        padding: 0 20px 1px 20px;
      }
      .w-80 {
        width: 80%;
      }

      &__item {
        display: inline-block;
        p {
          display: inline-block;
          width: 85%;
        }
      }
      .w-auto {
        width: auto;
      }
      .w-100 {
        width: 100%;
      }
      li:hover {
        background-color: #fff;
      }
      li a {
        padding: 3px 8px;
        margin: 0;
        background: #999;
        color: #fff;
        //width: 55px;
        height: 24px;
        text-align: center;
        line-height: 24px;
        font-size: 12px;
        border-radius: 3px;
      }
      .pl-0 {
        padding: 0 8px;
      }
      li p {
        font-size: 12px;
        line-height: 24px;
        position: relative;
        span {
          margin-right: 5px;
        }
        a {
          //float: right;
          display: inline-block;
          margin-left: 20px;
          position: absolute;
          right: 0;
        }
      }

      .consignee {
        display: inline-block;
        width: 100px;
        height: 26px;
        border: 1px solid #eaeaea;
        margin-right: 14px;
        line-height: 26px;
        text-align: center;
        background: #fff;
        cursor: pointer;
      }
      .consignee:hover {
        border: 1px solid #df5813;
      }
      .active {
        border: 1px solid #df5813;
        background: url('../../../assets/imgs/invoice-select.png') right bottom no-repeat;
      }
    }
    .more {
      height: 50px;
      overflow: hidden;
    }
    .h-130 {
      height: 130px;
      overflow: hidden;
    }
    &__opt {
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      .more-address {
        margin-right: 30px;
        color: #515151;
        cursor: pointer;
      }
      .mr-0 {
        margin-right: 0;
      }
    }
    .prl-20 {
      padding: 0 20px;
    }
    .btn {
      width: 70px;
      height: 30px;
      font-weight: 500;
      color: #ffffff;
      line-height: 30px;
      background-color: #df5813;
      border-radius: 6px;
      text-align: center;
      cursor: pointer;
      margin-left: auto;
    }
    .w-100 {
      width: 100px;
    }
    /*.mobile-btn {
      width: 100px;
      height: 30px;
      font-weight: 500;
      color: #ffffff;
      line-height: 30px;
      background-color: #df5813;
      text-align: center;
      cursor: pointer;
      margin-left: auto;
    }*/
  }
  .pr-0 {
    padding-right: 0;
  }
  &__footer {
    position: fixed;
    bottom: 0;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    height: 60px;
    background: #fff;
    column-gap: 40px;
    .mobile-btn {
      display: inline-block;
      width: 100px;
      height: 30px;
      line-height: 30px;
      background-color: #df5813;
      color: #fff;
      text-align: center;
    }
    .mobile-btn:first-child {
      background: #999;
    }
  }
}
</style>
